<template>
  <v-menu
    :value="selectedOpen"
    :close-on-content-click="false"
    :activator="selectedElement"
    offset-x
    @input="$emit('update:selectedOpen', $event)"
  >
    <v-card
      v-if="selectedEvent"
      color="grey lighten-4"
      flat
      style="padding: 0"
      class="eventMenu"
    >
      <v-toolbar
        color="#e6e6e6"
        flat
        height="50"
      >
        <a
          v-if="selectedEvent.appointmentNumber !== 0"
          style="text-decoration: underline"
          @click="gotoAppointment(selectedEvent.appointmentNumber)"
        >
          #{{ selectedEvent.appointmentNumber }}
        </a>
        <v-spacer />

        <appointment-menu
          v-if="selectedEvent && canWriteAppointmentsAndClients"
          :appointment-date="selectedEvent.start"
          :appointment="selectedEvent"
          :appointment-id="selectedEvent.appointmentId"
          :spread="true"
          @deleted="$emit('deleted')"
          @moved="$emit('moved')"
          @changecustomer="$emit('moved')"
          @move="$emit('move', $event)"
        />

        <v-btn
          class="ml-1"
          style="margin-right: -5px"
          fab
          x-small
          @click="closeMenu"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <appointment-summary
          :selected-event="selectedEvent"
          @close="onSummaryClose"
        />
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import AppointmentMenu from "../../AppointmentMenu.vue";
import AppointmentSummary from "@/components/global/AppointmentSummary.vue";
import { userPermissionsModule } from "@/store/modules/userPermissionsModule/userPermissionsModule";

@Component({
  components: {
    AppointmentMenu,
    AppointmentSummary,
  },
})
export default class EventMenu extends Vue {
  @Prop({ default: null }) selectedEvent!: any; // Replace 'any' with the correct type
  @Prop({ required: true }) selectedOpen!: boolean;
  @Prop({ required: true }) selectedElement!: Element | null;

  get canWriteAppointmentsAndClients() {
    return userPermissionsModule.canWriteAppointmentsAndClients;
  }
  closeMenu() {
    this.$emit("update:selectedOpen", false);
  }

  gotoAppointment(appointmentNumber: number) {
    this.$emit("goto-appointment", appointmentNumber);
  }

  onSummaryClose() {
    this.$emit("summary-close");
  }
}
</script>

<style scoped>
/* Existing styles (if any) */
</style>
